import Vue from 'vue'
import Router from 'vue-router'
import PublicLayout from '@/layouts/Public'
// import AuthLayout from '@/layouts/Auth'
import MainLayout from '@/layouts/Main'
import store from '@/store'
import { firebaseAuth } from '@/services/firebase'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/app',
      redirect: '/dashboard',
      component: MainLayout,
      meta: {
        authRequired: true,
        subscriptionRequired: true,
        hidden: true,
      },
      children: [
        {
          path: '/strategy',
          meta: {
            title: 'Strategy',
          },
          component: () => import('./pages/strategy'),
        },
        {
          path: '/dashboard',
          meta: {
            title: 'Dashboard',
          },
          component: () => import('./pages/dashboard'),
        },
        {
          path: '/videos',
          meta: {
            title: 'Videos',
          },
          component: () => import('./pages/videos'),
        },
        {
          path: '/upcoming',
          meta: {
            title: 'Videos',
          },
          component: () => import('./components/plannervid/videos/listUpcoming'),
        },
        {
          path: '/published',
          meta: {
            title: 'Videos',
          },
          component: () => import('./components/plannervid/videos/listPublished'),
        },
        {
          path: '/videodetails/:videoID',
          name: 'video-details',
          meta: {
            title: ':videoID',
          },
          component: () => import('./components/plannervid/videos/details'),
        },
        // {
        //   path: '/calendar',
        //   meta: {
        //     title: 'Calendar',
        //   },
        //   component: () => import('./pages/calendar'),
        // },
        {
          path: '/ideas',
          meta: {
            title: 'Ideas',
          },
          component: () => import('./pages/ideas'),
        },
        {
          path: '/collabs',
          meta: {
            title: 'Collabs',
          },
          component: () => import('./pages/collabs'),
        },
        // {
        //   path: '/turbo',
        //   meta: {
        //     title: 'Turbo',
        //   },
        //   component: () => import('./pages/turbo'),
        // },
        {
          path: '/accountinfo',
          name: 'account-info',
          meta: {
            title: 'Account Info',
          },
          component: () => import('./pages/account'),
        },
      ],
    },

    // Funnel Pages
    {
      path: '/',
      component: PublicLayout,
      redirect: '/dashboard',
      meta: {
        authRequired: false,
      },
      children: [
        // {
        //   name: 'createaccount',
        //   path: '/createaccount',
        //   meta: {
        //     title: 'Complete Tool for 100K YouTube Subscribers',
        //   },
        //   component: () => import('./pages/funnel/accountcreation'),
        // },
        {
          name: 'createaccount-step-1',
          path: '/createaccount-step-1',
          meta: {
            title: 'Create Your Account',
          },
          component: () => import('./pages/funnel/createaccount-step-1'),
        },
        {
          name: 'createaccount-step-2',
          path: '/createaccount-step-2',
          meta: {
            title: 'Who are you?',
            authRequired: true,
          },
          component: () => import('./pages/funnel/createaccount-step-2'),
        },
        {
          name: 'createaccount-step-3',
          path: '/createaccount-step-3',
          meta: {
            title: 'Start 7-day Trial',
            authRequired: true,
          },
          component: () => import('./pages/funnel/createaccount-step-3'),
        },
        {
          name: 'creatorwelcome',
          path: '/creatorwelcome',
          meta: {
            title: 'Welcome, Creator.',
            authRequired: true,
          },
          component: () => import('./pages/funnel/welcome-creator'),
        },
      ],
    },

    // System Pages
    {
      path: '/auth',
      component: PublicLayout,
      redirect: 'auth/login',
      children: [
        {
          path: '/auth/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/auth/404'),
        },
        {
          path: '/auth/500',
          meta: {
            title: 'Error 500',
          },
          component: () => import('./views/auth/500'),
        },
        {
          path: '/auth/login',
          meta: {
            title: 'Sign In',
            guestRequired: true,
          },
          component: () => import('./views/auth/login'),
        },
        {
          path: '/auth/managesubscriptionaccess',
          meta: {
            title: 'Update Payment Details',
            authRequired: true,
          },
          component: () => import('./pages/funnel/subscriptionFailure'),
        },
        {
          path: '/auth/forgot-password',
          meta: {
            title: 'Forgot Password',
            guestRequired: true,
          },
          component: () => import('./views/auth/forgot-password'),
        },
        {
          path: '/auth/lockscreen',
          meta: {
            title: 'Lockscreen',
          },
          component: () => import('./views/auth/lockscreen'),
        },
        {
          path: '/privacypolicy',
          meta: {
            title: 'Privacy Policy',
          },
          component: () => import('./pages/legal/privacy.vue'),
        },
        {
          path: '/termsofuse',
          meta: {
            title: 'Terms of Use',
          },
          component: () => import('./pages/legal/termsofuse.vue'),
        },
      ],
    },

    // Redirect to 404
    {
      path: '*', redirect: 'auth/404', hidden: true,
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.subscriptionRequired)) {
    if (store.state.user.subscriptionStatus !== 'active' &&
        store.state.user.subscriptionStatus !== 'trialing' &&
        store.state.user.subscriptionStatus !== 'past_due' &&
        store.state.user.subscriptionStatus !== 'lifetime') {
      next({
        path: '/auth/managesubscriptionaccess',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

// Nav Guards
router.beforeEach((to, from, next) => {
  // Check for requiresAuth guard
  if (to.matched.some(record => record.meta.authRequired)) {
    // Check if NO logged user
    if (!firebaseAuth.currentUser) {
      // Go to login
      next({
        path: '/auth/login',
        query: {
          redirect: to.fullPath,
        },
      })
    } else {
      // Proceed to route
      next()
    }
  } else if (to.matched.some(record => record.meta.guestRequired)) {
    // Check if NO logged user
    if (firebaseAuth.currentUser) {
      // Go to login
      next({
        path: '/dashboard',
      })
    } else {
      // Proceed to route
      next()
    }
  } else {
    // Proceed to route
    next()
  }
})

export default router
